// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","dark":"App_dark__sU4Z9"};